/**
 *
 * FlexButton
 *
 */

import React, { useState } from 'react';
// import PropTypes from 'prop-types';
// import styled from 'styled-components';

import styles from './styles.module.css';

import { Icon } from 'semantic-ui-react';

import FlexBox from 'components/common/FlexBox';
import FlexPopup from 'components/common/FlexPopup';
function FlexButton(props) {
  let {
    align,
    justify,
    id,
    icon,
    width,
    tooltip,
    style,
    gutter = 10,
    disabled,
    material,
    squared,
    transparent,
    shrinkable,
    color,
    primary,
    guttered,
    vstretch,
    hstretch,
    rightGutter,
    bottomGutter,
    leftGutter,
    topGutter,
    fill,
    onClick,
    loading,
    compact,
    blueprint,
    text,
    subtext,
    nowrap,
    messageOnClick,
    circular,
  } = props;

  const [clickMessageActive, setClickMessageActive] = useState(false);

  let elemStyle = style ? { ...style } : {};
  if (rightGutter || guttered) {
    elemStyle.marginRight = `${gutter}px`;
  }

  if (bottomGutter || guttered) {
    elemStyle.marginBottom = `${gutter}px`;
  }

  if (leftGutter || guttered) {
    elemStyle.marginLeft = `${gutter}px`;
  }

  if (topGutter || guttered) {
    elemStyle.marginTop = `${gutter}px`;
  }

  if (align) {
    elemStyle.alignItems = align;
  }

  if (justify) {
    elemStyle.justifyContent = justify;
  }

  if (fill) {
    elemStyle.height = '100%';
    elemStyle.width = '100%';
  }

  if (vstretch) {
    elemStyle.height = '100%';
    elemStyle.overflowY = 'auto';
  }

  if (hstretch || props.fluid) {
    elemStyle.width = '100%';
  }

  if (width) {
    elemStyle.minWidth = `${width}px`;
  }

  if (nowrap) {
    elemStyle.whiteSpace = 'nowrap';
  }

  let classes = `${styles.flexButton}`;
  if (primary) {
    classes += ` ${styles.primary}`;
  }
  if (props.secondary) {
    classes += ` ${styles.secondary}`;
  }
  if (props.destructive) {
    classes += ` ${styles.destructive}`;
  }
  if (color) {
    classes += ` ${styles[color]}`;
  }
  if (loading) {
    classes += ` ${styles.loading}`;
  }
  if (props.invertLoading) {
    classes += ` ${styles.invertLoading}`;
  }
  if (props.className) {
    classes = `${props.className} ` + classes;
  }
  if (circular) {
    classes = `${styles.circular} ` + classes;
  }

  const handleOnClick = (e) => {
    if (onClick && !loading) {
      onClick(e);
      if (messageOnClick) {
        setClickMessageActive(true);
        setTimeout(() => {
          setClickMessageActive(false);
        }, 2000);
      }
    }
  };

  elemStyle.fontWeight = '700px';

  if (transparent) {
    classes += ` ${styles.transparent}`;
  }

  if (disabled) {
    classes += ` ${styles.buttonDisabled}`;
  }

  if (compact) {
    classes += ` ${styles.compact}`;
  }

  if (squared) {
    elemStyle.borderRadius = '5px';
  }

  let iconStyle = props.iconStyle ? { ...props.iconStyle } : {};
  if (!props.children || props.children.length === 0) {
    iconStyle.marginRight = 0;
  }

  if (blueprint) {
    classes += ` ${styles.blueprint}`;
  }

  let textStyle = {};
  let subtextStyle = {};
  let textContentStyle = {};
  if (props.textStyle) {
    textStyle = props.textStyle;
  }

  if (props.subtextStyle) {
    subtextStyle = props.subtextStyle;
  }

  if (loading) {
    classes += ` ${styles.buttonDisabled}`;
  }

  if (align) {
    textContentStyle.alignItems = align;
  }

  if (justify) {
    textContentStyle.justifyContent = justify;
  }

  if (props.iconStyle) {
    iconStyle = props.iconStyle;
  }

  if (text && !subtext && !align) {
    align = 'center';
  }

  let standardContentStyle = {};
  if (props.textAlign) {
    textStyle.textAlign = props.textAlign;
    subtextStyle.textAlign = props.textAlign;
    standardContentStyle.justifyContent = 'flex-start';
  }

  if (!onClick) {
    elemStyle.pointerEvents = 'none';
  }

  if (props.badge) {
    elemStyle.paddingTop = 0;
    elemStyle.paddingBottom = 0;
    elemStyle.paddingLeft = 6;
    elemStyle.paddingRight = 6;
    elemStyle.minHeight = 24;
  }

  if (props.background) {
    elemStyle.background = props.background;
  }

  if (props.foreground) {
    elemStyle.color = props.foreground;
  }

  if (!text && !subtext && !props.children) {
    classes += ` ${styles.iconOnly}`;
  }

  let buttonContent = (
    <div onClick={handleOnClick} className={classes} style={elemStyle} data-testid="flex-button">
      {!loading && (
        <div
          style={standardContentStyle}
          className={`${styles.standardContent} ${clickMessageActive ? styles.messageActive : ''}`}
        >
          {!loading && icon && !material && <Icon style={iconStyle} name={icon} />}
          {!loading && icon && material && (
            <div style={iconStyle} className={`${styles.materialIcon} material-icons`}>
              {icon}
            </div>
          )}
          {(text || subtext || props.children) && (
            <div
              style={{ marginLeft: text || subtext ? 2 : 0 }}
              className={`${styles.childContainer} ${shrinkable ? styles.shrinkable : ''}`}
            >
              {!loading && (text || subtext) && (
                <FlexBox
                  style={{ marginLeft: icon ? 5 : 0, padding: '5px 0px', ...textContentStyle }}
                  justify={justify ? justify : undefined}
                  align={align ? align : 'flex-start'}
                  column
                >
                  {text && (
                    <div style={textStyle} className={`${styles.buttonText} ${!icon ? styles.textOnly : ''}`}>
                      {text}
                    </div>
                  )}
                  {subtext && (
                    <div style={subtextStyle} className={styles.buttonSubtext}>
                      {subtext}
                    </div>
                  )}
                </FlexBox>
              )}
              {loading ? undefined : props.children}
            </div>
          )}
        </div>
      )}
      {clickMessageActive && <div className={styles.clickMessage}>{messageOnClick}</div>}
    </div>
  );

  if (tooltip) {
    return (
      <FlexPopup
        type="tooltip"
        position={props.tooltipPosition ? props.tooltipPosition : 'bottom middle'}
        open={props.tooltipOpen}
        content={tooltip}
      >
        {buttonContent}
      </FlexPopup>
    );
  } else {
    return buttonContent;
  }
}

FlexButton.propTypes = {};

export default FlexButton;
